export default __webpack_public_path__ + "static/media/trikot_base_bg_screen_empty.2621de56.png";